var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var Flag = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 28px;\n  height: 20px;\n  vertical-align: middle;\n  margin-right: 8px;\n"], ["\n  width: 28px;\n  height: 20px;\n  vertical-align: middle;\n  margin-right: 8px;\n"])));
export default {};
var templateObject_1;
